"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Listbox = void 0;
var react_1 = __importDefault(require("react"));
exports.Listbox = function (props) {
    var _a;
    return (react_1.default.createElement("div", __assign({}, props, { className: "l-grid__item +span-3 u-overflow-auto u-border " + ((_a = props.className) !== null && _a !== void 0 ? _a : "") })));
};
//# sourceMappingURL=Listbox.js.map